import { PiwikAction, PiwikCategory, PiwikName } from '../@types/common';
import { trackEvent } from '../api/piwik/piwikService';

export const addTrackEvent = (name: PiwikName) => {
  trackEvent({
    category: PiwikCategory.BUTTONS,
    action: PiwikAction.CLICKED,
    name: name
  });
};

export const trackFilterEvents = (filter: string) => {
  switch (filter) {
    case 'active':
      addTrackEvent(PiwikName.FILTER_ACTIVE);
      break;
    case 'inactive':
      addTrackEvent(PiwikName.FILTER_INACTIVE);
      break;
    case 'draft':
      addTrackEvent(PiwikName.FILTER_DRAFTS);
      break;
    default:
      break;
  }
};
